import { number, object, SchemaOf, string } from "yup";
import { yupGsdbValidation } from "../../Forms/yupGsdbValidation";
import { nameOf } from "../../Utils/nameOf";
import Supplier from "../Supplier";
import { yupTimesValidation } from "../../Forms/yupTimesValidation";

// exemplarische Validierung - Im Zuge des Tickets entsprechend erweitern
export const supplierSchema: SchemaOf<Supplier> = object()
  .shape({
    Gsdb: yupGsdbValidation(nameOf<Supplier>("Gsdb")),
    Name: string().required().default(""),
    CountryID: number().notOneOf([null, 0], "Please choose a country"),
    DefaultLoadingTime: yupTimesValidation(nameOf<Supplier>("DefaultLoadingTime")),
  })
  .required();
